import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PageHero({ eyebrow, title, subtitle, image, crumbs = [] }) {
  return (
    <section className="relative min-h-[62vh] flex items-end overflow-hidden" data-testid="page-hero">
      <div className="absolute inset-0">
        <img src={image} alt={title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/85 via-forest-deep/40 to-forest-deep/20" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 pb-16 pt-32 w-full">
        {crumbs.length > 0 && (
          <nav className="mb-5 text-xs tracking-widest uppercase text-bone/70 flex gap-2" aria-label="Breadcrumb">
            {crumbs.map((c, i) => (
              <span key={c.path} className="flex gap-2">
                {i > 0 && <span>/</span>}
                {i < crumbs.length - 1 ? (
                  <Link to={c.path} className="hover:text-amber transition-colors">
                    {c.name}
                  </Link>
                ) : (
                  <span className="text-amber">{c.name}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        {eyebrow && <span className="text-xs uppercase tracking-[0.25em] text-amber">{eyebrow}</span>}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-serif text-5xl md:text-6xl lg:text-7xl text-bone tracking-tight leading-[1.02] mt-4 max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && <p className="mt-6 text-lg text-bone/85 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
